/**
 * after a pdf is uploaded, total page count should be shown as meta data.
 * ref: https://stackoverflow.com/a/39222676
 * @param file File
 * @returns page count
 */
export const getInlinePdfPageCount = (file: File): Promise<number> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onloadend = function () {
      const count = (reader.result as string)?.match(/\/Type[\s]*\/Page[^s]/g)?.length || 0;
      resolve(count);
    };
  });
};
